import { defineWebExtension } from '@databink/web/extension';
import { SurveysGuide } from './help.js';
import { INSTALLATIONS, OpportunitySurveys, UpcomingSurveys } from './surveys.js';

/**
 * Acme's screen extensions, compiled into Acme's build of the web app
 * (DATABINK_CLIENT=acme). The slots filled here are the ones src/index.ts declares, which
 * `databink client verify` checks against the core's registry; test/web.test.ts keeps the
 * two lists in step.
 */
export default defineWebExtension({
  client: 'acme',
  slots: {
    'crm.opportunity.detail.tabs': [
      {
        id: 'site-surveys',
        label: 'Site surveys',
        component: OpportunitySurveys,
        when: (record) => record['pipeline'] === INSTALLATIONS,
      },
    ],
    'app.dashboard': [
      { id: 'upcoming-surveys', title: 'Upcoming site surveys', component: UpcomingSurveys },
    ],
    'app.help': [
      {
        id: 'site-surveys',
        title: 'Site surveys',
        summary: 'Booking and completing the survey every installation needs.',
        component: SurveysGuide,
        // For the people who book and carry out surveys, not, say, finance.
        when: (meta) => meta.entities.some((e) => e.id === 'ext.site_survey'),
      },
    ],
  },
});
